import { render } from "./ShadowTeamView.vue?vue&type=template&id=72b40a96"
import script from "./ShadowTeamView.vue?vue&type=script&lang=js"
export * from "./ShadowTeamView.vue?vue&type=script&lang=js"

import "./ShadowTeamView.vue?vue&type=style&index=0&id=72b40a96&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__